import { createSlice } from '@reduxjs/toolkit';
import {
  createQuickBooksAssociation,
  createQuickBooksInvoice,
  disassociateQuickBooksCustomer,
  loadQuickBooks,
  loadQuickBooksAssociations,
  loadQuickBooksCustomers,
} from '@sophocles/features/quickbooks/api';
import { produce } from 'immer';

const slice = createSlice({
  name: 'quickbooks',
  initialState: {
    authorizationUrl: null,
    company: null,
    associations: [],
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(loadQuickBooks.fulfilled, (state, action) => {
        state.authorizationUrl = action.payload.authorizationUrl;
        state.company = action.payload.company;
        state.associations = action.payload.customers;
      })
      .addCase(loadQuickBooks.rejected, (state, action) => {
        console.log('failed to load quickbooks', action);
      })
      .addCase(loadQuickBooksAssociations.fulfilled, (state, action) => {
        state.associations = action.payload;
      })
      .addCase(loadQuickBooksAssociations.rejected, (state, action) => {
        console.log('failed to load quickbooks assocs', action);
      })
      .addCase(loadQuickBooksCustomers.fulfilled, (state, action) => {
        state.associations = action.payload.customers;
      })
      .addCase(loadQuickBooksCustomers.rejected, (state, action) => {
        console.log('failed to load quickbooks customers', action);
      })
      .addCase(createQuickBooksInvoice.fulfilled, (state, action) => {
        const invoiceId = action.payload.qb_invoice_id;
      })
      .addCase(createQuickBooksInvoice.rejected, (state, action) => {
        console.log('failed to create quickbooks invoice', action);
      })
      .addCase(createQuickBooksAssociation.fulfilled, (state, action) => {
        const { associated, quickBooksCustomerId, customerId, siteGroupId } = action.payload;

        if (associated === true) {
          const association = state.associations.find(a => a.association.Id == quickBooksCustomerId);
          if (association != null) {
            association.customer_ids.push(customerId);
            association.site_group_ids.push(siteGroupId);
          }
        }
      })
      .addCase(createQuickBooksAssociation.rejected, (state, action) => {
        console.log('failed to create quickbooks association', action);
      })
      .addCase(disassociateQuickBooksCustomer.fulfilled, (state, action) => {
        const { disassociated, siteGroupId } = action.payload;

        if (disassociated === true) {
          const association = state.associations.find(a => a.site_group_ids.includes(siteGroupId));
          if (association != null) {
            const siteGroupIndex = association.site_group_ids.indexOf(siteGroupId);
            association.site_group_ids = produce(association.site_group_ids, draft => {
              draft.splice(siteGroupIndex, 1);
              return draft;
            });
          }
        }
      })
      .addCase(disassociateQuickBooksCustomer.rejected, (state, action) => {
        console.log('failed to disassociate quickbooks customer', action);
      });
  },
});

export const selectQuickBooksAuthorizationUrl = state => {
  return state.quickbooks.authorizationUrl;
};

export const selectQuickBooksCompany = state => {
  return state.quickbooks.company;
};

export const selectQuickBooksAssociations = state => {
  return state.quickbooks.associations;
};

export const selectQuickBooksCustomers = state => {
  return state.quickbooks.associations.map(c => c.association);
};

const { reducer } = slice;
export default reducer;
